<template>
	<div class="overall-cls">
		<div @click.stop="handleView(item, index)" class="cell" :class="{'active': StoreSessionCurrentNode.uuid === item.uuid, 'no-border': StoreSessionList.length - 1 == index}" v-for="(item, index) in StoreSessionList" :key="item.uuid">
			<div class="item">
				<div class="top">
					<span class="q">{{item.q}}</span>
					<span class="date">{{item.createAt}}</span>
					<svg-icon @click.stop="handleClose(item, index)" icon-class="KnowClose" />
				</div>
				<div class="bottom" v-if="item.remark">
					<span class="label">备注</span>
					<span class="text">{{item.remark}}</span>
				</div>
			</div>
		</div>
		<el-divider v-if="StoreHistoryList.length > 0"><el-link type="info" :underline="false">已结束会话</el-link></el-divider>
		<div @click.stop="handleView(item, index)" class="cell disable" v-for="(item, index) in StoreHistoryList" :key="item.uuid">
			<div class="item">
				<div class="top">
					<span class="q">{{item.q}}</span>
					<span class="date">{{item.createAt}}</span>
				</div>
				<div class="bottom" v-if="item.remark">
					<span class="label">备注</span>
					<span class="text">{{item.remark}}</span>
				</div>
			</div>
		</div>
		<el-empty v-if="StoreSessionList.length === 0 && StoreHistoryList.length === 0" description="暂无数据"></el-empty>
	</div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
export default {
	name: 'KnowledgeSessionTabs',
	computed: {
		...mapGetters([
			'StoreSessionList',
			'StoreHistoryList',
			'StoreSessionCurrentNode'
		])
	},
	data() {
		return {
			historyCurrentId: '',
		}
	},
	methods: {
		...mapMutations({
			'SET_SESSION_LIST_ADD': 'knowService/SET_SESSION_LIST_ADD',
			'SET_SESSION_LIST_DELETE': 'knowService/SET_SESSION_LIST_DELETE',
			'SET_HISTORY_LIST': 'knowService/SET_HISTORY_LIST',
			'SET_SESSION_CURRENT_NODE': 'knowService/SET_SESSION_CURRENT_NODE'
		}),
		handleView(item, index) {
			this.$emit('sessionKnowInfo', item);
			item.index = index;
			this.SET_SESSION_CURRENT_NODE(item);
		},
		handleClose(item, index) {
			// this.$confirm("是否结束此会话？","系统提示",{
			// 	confirmButtonText: "确认",
			// 	cancelButtonText: "取消",
			// 	type: "warning"
			// }).then(() => {
				this.SET_SESSION_LIST_DELETE(index);
				item.isEnd = true;
				// item.uuid = generateUUID();
				this.SET_HISTORY_LIST(item);
				this.$emit('sessionEmitClose');
			// });
		}
	}
}
</script>

<style lang="scss" scoped>
.overall-cls {
	width: 100%;
	height: calc(100% - 45px);
	overflow-x: hidden;
	overflow-y: auto;

	& > .cell {
		width: 100%;
		height: 65px;
		padding: 0 20px;
		box-sizing: border-box;

		&.active, &:hover {
			background: #EDF5FF;

			& > .item > .top > .q {
				color: #337EFF;
			}
		}

		&:hover {
			& > .item > .top > .svg-icon {
				display: block;
			}
			& > .item > .top > .date {
				color: transparent;
			}
		}

		&.no-border > .item {
			border-bottom: none;
		}

		&.disable {
			& > .item {
				& > .top > .q, & > .bottom > .text {
					color: #C0C0C0;
				}

				& > .bottom > .label {
					color: #A6AAB8;
					background: #E6E9EF;
				}

				& > .top > .date {
					color: #6C7E91;
				}
			}
		}

		& > .item {
			width: 100%;
			height: 100%;
			border-bottom: 1px solid #D8D8D8;
			padding: 9px 0;
			box-sizing: border-box;
			cursor: pointer;

			& > div {
				width: 100%;
				line-height: 20px;
				margin-top: 2px;
				font-size: 14px;
				font-weight: 400;
				line-height: 20px;

				&.top {
					width: 100%;
					display: block;
					text-align: right;
					position: relative;

					& > .svg-icon {
						display: none;
						position: absolute;
						color: #566980;
						font-size: 14px;
						top: 12px;
						right: 0;
					}

					& > .q {
						display: inline-block;
						width: calc(100% - 50px);
						overflow: hidden;
						white-space: nowrap;
						text-overflow: ellipsis;
						text-align: left;
						color: #3C4353;
					}

					& > .date {
						width: 50px;
						display: inline-block;
						overflow: hidden;
						white-space: nowrap;
						text-overflow: ellipsis;
						color: #6C7E91;
					}
				}

				&.bottom {
					width: 100%;

					& > span {
						display: inline-block;
						vertical-align: top;
						font-size: 12px;
						font-weight: 400;

						&.label {
							width: 42px;
							height: 20px;
							background: #FDF4E8;
							border-radius: 10px;
							text-align: center;
							color: #F29522;
							margin-right: 4px;
						}

						&.text {
							width: 200px;
							overflow: hidden;
							white-space: nowrap;
							text-overflow: ellipsis;
							color: #838A9D;
						}
					}
				}
			}
		}
	}
}
</style>